import React from "react";
import { AnnotationLens } from "react-mindee-js";

interface LensProps {
  pointerPosition: { x: number; y: number };
  annotationData: any;
  isDisplay: boolean;
}

export default function Lens({
  pointerPosition,
  annotationData,
  isDisplay,
}: Readonly <LensProps>) {
  return (
    <>
      {isDisplay && (
        <AnnotationLens
          pointerPosition={pointerPosition}
          zoomLevel={1.5}
          style={{
            width: "100%",
            height: "150px",
            background: "#f1f3f5",
            border: "solid 2px #a5a5a5",
            overflow: "hidden",
          }}
          data={annotationData}
        />
      )}
    </>
  );
}
